'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var XCircleIcon = require('@narvar/nth-bit-icon-x-circle');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var PanelContentHeader = require('@narvar/nth-block-panel-content-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var types = require('../../types.js');
var ErrorAPI_module = require('./ErrorAPI.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var XCircleIcon__default = /*#__PURE__*/_interopDefaultLegacy(XCircleIcon);
var PanelContentHeader__default = /*#__PURE__*/_interopDefaultLegacy(PanelContentHeader);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const ErrorAPI = ({
  featureName,
  layout = FeatureLayout.PORTRAIT,
  channel,
  customApiErrorMessage
}) => {
  const {
    bodytextDefaultNone: errorMessageStyle
  } = nthHookTheme.useTheme();
  const {
    notificationCenterSmsApiErrorHeader,
    notificationCenterSmsApiErrorMessage,
    notificationCenterEmailApiErrorHeader,
    notificationCenterEmailApiErrorMessage,
    notificationCenterLineApiErrorHeader,
    notificationCenterLineApiErrorMessage
  } = nthHookTranslations.useTranslations();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  const smsErrorChannelProps = {
    apiErrorHeader: notificationCenterSmsApiErrorHeader || '',
    apiErrorMessage: notificationCenterSmsApiErrorMessage || '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER
  };
  const emailErrorChannelProps = {
    apiErrorHeader: notificationCenterEmailApiErrorHeader || '',
    apiErrorMessage: notificationCenterEmailApiErrorMessage || '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EMAIL_NOTIFICATION_CENTER
  };
  const lineErrorChannelProps = {
    apiErrorHeader: notificationCenterLineApiErrorHeader || '',
    apiErrorMessage: notificationCenterLineApiErrorMessage || '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_LINE_NOTIFICATION_CENTER
  };
  const errorChannelProps = {
    [types.Channels.SMS]: smsErrorChannelProps,
    [types.Channels.HIPAA_SMS]: smsErrorChannelProps,
    [types.Channels.EMAIL]: emailErrorChannelProps,
    [types.Channels.HIPAA_EMAIL]: emailErrorChannelProps,
    [types.Channels.LINE]: lineErrorChannelProps,
    [types.Channels.SUBLIME]: smsErrorChannelProps
  };
  const {
    apiErrorHeader = '',
    apiErrorMessage = '',
    eventComponent = ''
  } = channel !== types.Channels.APP_PUSH ? errorChannelProps[channel] : {};
  React.useEffect(() => {
    logEvent({
      eventComponent,
      eventFeature: eventComponent,
      eventNotificationSignUpError: apiErrorMessage,
      eventType: nthHookContextAnalytics.NarvarEventTypes.ERROR,
      feature: featureName,
      pageComponent: eventComponent
    });
  }, [apiErrorMessage, eventComponent, featureName, logEvent]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: isLandscape ? ErrorAPI_module["default"].errorContainerLandscape : ErrorAPI_module["default"].errorContainer,
    "data-test": `${channel}NotificationCenterErrorAPI`
  }, /*#__PURE__*/React__default["default"].createElement(PanelContentHeader__default["default"], {
    as: "p",
    icon: /*#__PURE__*/React__default["default"].createElement(XCircleIcon__default["default"], {
      featureName: featureName
    }),
    headerText: apiErrorHeader || '',
    headerTextRole: "status",
    paragraphChildren: /*#__PURE__*/React__default["default"].createElement("div", {
      style: errorMessageStyle
    }, customApiErrorMessage ?? apiErrorMessage),
    isLandscape: isLandscape
  }));
};
var ErrorAPI$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(ErrorAPI, {
  themeTokens: ['bodytextDefaultNone']
}), {
  translationKeys: ['notificationCenterSmsApiErrorHeader', 'notificationCenterSmsApiErrorMessage', 'notificationCenterEmailApiErrorHeader', 'notificationCenterEmailApiErrorMessage', 'notificationCenterLineApiErrorHeader', 'notificationCenterLineApiErrorMessage']
});

exports["default"] = ErrorAPI$1;
